import React from 'react'
import { ExclamationTriangleIcon, LockClosedIcon } from '@heroicons/react/24/outline'
// Card marks from react-payment-logos (MIT), not drawn here.
import Visa from 'react-payment-logos/dist/flat/Visa'
import Mastercard from 'react-payment-logos/dist/flat/Mastercard'
import Amex from 'react-payment-logos/dist/flat/Amex'
import Discover from 'react-payment-logos/dist/flat/Discover'
import { StripeKeyMode, stripeKeyMode } from '../../services/stripe'

const CARDS = [
  { name: 'Visa', Logo: Visa },
  { name: 'Mastercard', Logo: Mastercard },
  { name: 'American Express', Logo: Amex },
  { name: 'Discover', Logo: Discover },
]

/** "Secure payments by Stripe" with the accepted cards, under every card form. */
export const SecurePaymentsLine: React.FC = () => (
  <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600">
    <span className="inline-flex items-center gap-1">
      <LockClosedIcon className="h-4 w-4" aria-hidden="true" />
      Secure payments by Stripe
    </span>
    <span className="flex items-center gap-1" aria-label="Accepted cards">
      {CARDS.map(({ name, Logo }) => (
        <Logo key={name} width={32} height={20} role="img" aria-label={name} />
      ))}
    </span>
  </div>
)

/** The test-mode card to use; shown only with a pk_test_ key. */
export const TestModeNotice: React.FC<{ mode?: StripeKeyMode }> = ({ mode = stripeKeyMode() }) =>
  mode === 'test' ? (
    <div
      role="note"
      className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800"
    >
      <ExclamationTriangleIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span>Test mode — use card 4242 4242 4242 4242. No real charges.</span>
    </div>
  ) : null

/** In place of a card form when there's no publishable key to load Stripe with. */
export const PaymentsNotSetUp: React.FC = () => (
  <div className="rounded-md border border-gray-200 bg-gray-50 px-4 py-6 text-center">
    <LockClosedIcon className="h-6 w-6 text-gray-400 mx-auto mb-2" aria-hidden="true" />
    <p className="text-sm font-medium text-gray-900">Payments aren't set up yet</p>
    <p className="text-xs text-gray-600 mt-1">
      Card payments will appear here once Stripe is connected.
    </p>
  </div>
)
